import React, { useEffect, useRef, useState } from "react";
import s from "./styles.module.css";
import TableElement from "../../../../components/table_element";
import classNames from "classnames";

const TableItem = ({
                       setNewScore,
                       index,
                       isOpen,
                       addNewScore,
                       listScore,
                       part = "",
                       base_mark = "",
                       difficulty_code = "",
                       bonus = "",
                       dd = "",
                       fc_element,
                       result_element = "",
                       coach_tech_controls,
                       coach_element,
                       element_id,
                       number,
                       isReferee,
                       dd_comment,
                   }) => {
    const controls = (number) =>
        coach_tech_controls?.find((f) => f?.number_coach === number) || {};
    const coachElement = (number) =>
        coach_element.find((f) => f.number_coach === number) || {};
    const findIndexElement = (number) =>
        coach_element.findIndex((f) => f.number_coach === number) || 0;

    const [coloredChoose, setColoredChoose] = useState({
        color_1: controls(1)?.value || "0",
        color_2: controls(2)?.value || "0",
        color_3: controls(3)?.value || "0",
        process_1: controls(1)?.value ? "0" : controls(1)?.value_process || "0",
        process_2: controls(2)?.value ? "0" : controls(2)?.value_process || "0",
        process_3: controls(3)?.value ? "0" : controls(3)?.value_process || "0",
    });

    const dirtyKeys = useRef(new Set());
    const timers = useRef(new Map());
    const pendingChanges = useRef(new Map()); // Буфер для неподтвержденных изменений

    const handlerClick = (variant, id) => {
        if (!id) return;

        const newValue =
            coloredChoose[variant] === "0" ? "1" :
                coloredChoose[variant] === "1" ? "2" :
                    coloredChoose[variant] === "2" ? "3" : "0";

        // Обновляем локальное состояние
        setColoredChoose((prev) => ({
            ...prev,
            [variant]: newValue,
        }));

        // Добавляем в буфер неподтвержденных изменений
        dirtyKeys.current.add(variant);
        pendingChanges.current.set(variant, { value: newValue, id });

        // Очищаем существующий таймер
        if (timers.current.has(id)) {
            clearTimeout(timers.current.get(id));
            timers.current.delete(id);
        }

        // Устанавливаем таймер для отправки изменений
        const timeoutId = setTimeout(() => {
            // Предполагаем, что setNewScore возвращает Promise
            setNewScore(id, newValue, false).then(() => {
                // Удаляем из буфера только после успешной отправки
                dirtyKeys.current.delete(variant);
                pendingChanges.current.delete(variant);
                timers.current.delete(id);
            }).catch((error) => {
                console.error("Failed to save score:", error);
            });
        }, 3000);

        timers.current.set(id, timeoutId);
    };

    useEffect(() => {
        const next = {
            color_1: controls(1)?.value || "0",
            color_2: controls(2)?.value || "0",
            color_3: controls(3)?.value || "0",
            process_1: controls(1)?.value ? "0" : controls(1)?.value_process || "0",
            process_2: controls(2)?.value ? "0" : controls(2)?.value_process || "0",
            process_3: controls(3)?.value ? "0" : controls(3)?.value_process || "0",
        };

        setColoredChoose((prev) => {
            const updated = { ...prev };
            let changed = false;

            for (const key in next) {
                // Игнорируем ключи с неподтвержденными изменениями
                if (dirtyKeys.current.has(key) || pendingChanges.current.has(key)) {
                    continue;
                }

                if (prev[key] !== next[key]) {
                    updated[key] = next[key];
                    changed = true;
                }
            }

            // Применяем неподтвержденные изменения поверх серверных данных
            pendingChanges.current.forEach(({ value }, key) => {
                updated[key] = value;
                changed = true;
            });

            return changed ? updated : prev;
        });
    }, [coach_tech_controls]);

    return (
        <div className={s.item}>
            <div className={s.item_number}>{number}</div>

            <div className={s.elements_box}>
                <TableElement width={80} showTooltip={true}>
                    {part}
                </TableElement>
                <TableElement left={10} width={180} showTooltip={true}>
                    {difficulty_code}
                </TableElement>
                <TableElement left={10} width={118} showTooltip={true}>
                    {bonus}
                </TableElement>
            </div>

            {[1, 2, 3].map((num) => {
                const colorKey = `color_${num}`;
                const processKey = `process_${num}`;
                const ctrl = controls(num);
                return (
                    <TableElement
                        key={num}
                        disabled={!ctrl?.id}
                        className={classNames(
                            s.colored_picker,
                            coloredChoose[colorKey] === "1" && s.green,
                            coloredChoose[colorKey] === "2" && s.red,
                            coloredChoose[colorKey] === "3" && s.yellow,
                            coloredChoose[processKey] === "1" && s.green__process,
                            coloredChoose[processKey] === "2" && s.red__process,
                            coloredChoose[processKey] === "3" && s.yellow__process
                        )}
                        onClick={() => handlerClick(colorKey, ctrl?.id)}
                        left={10}
                        width={36}
                    >
                        {null}
                    </TableElement>
                );
            })}

            <TableElement
                toFixed={3}
                left={10}
                width={55}
                isEdit={true}
                tooltipValue={dd_comment}
                showTooltip
                isDD={!isReferee}
                disabled={isReferee}
                onChange={(value) => setNewScore(`dd_${element_id}`, value)}
            >
                {dd}
            </TableElement>

            <TableElement toFixed={2} left={15} width={50}>
                {fc_element}
            </TableElement>

            {[1, 2, 3, 4, 5].map((num) => {
                const elem = coachElement(num);
                const isProcess = elem?.value === null;
                return (
                    <TableElement
                        key={num}
                        isOpen={isOpen}
                        index={findIndexElement(num) + 5}
                        toFixed={2}
                        left={num === 1 ? 15 : 10}
                        width={50}
                        isEdit={true}
                        disabled={!elem?.id || isReferee || part === "SuCon"}
                        className={isProcess ? s.process_digit : s.main_digit}
                        onChange={(value) => setNewScore(elem?.id, value)}
                        setListScore={(value) => addNewScore(listScore, elem?.id, value)}
                    >
                        {isProcess ? elem?.value_process : elem?.value}
                    </TableElement>
                );
            })}

            <TableElement toFixed={4} left={10} width={90}>
                {result_element}
            </TableElement>
        </div>
    );
};

export default TableItem;